import React, { useEffect, useMemo, useState } from "react";
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
  Typography,
  Box,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import GoalIcon from "../../assets/images2/goals.svg";
import UserIcon from "../../assets/images2/users.svg";
import TournamentIcon from "../../assets/images2/tournaments.svg";
import FreeVotesIcon from "../../assets/images2/freeVotes.svg";
import LeaderboardIcon from "../../assets/images2/leaderboards.svg";
import LogoutIcon from "../../assets/images2/logout.svg";
import GoalIconA from "../../assets/images2/goalsSelec.svg";
import UserIconA from "../../assets/images2/usersSelec.svg";
import TournamentIconA from "../../assets/images2/tournamentSelec.svg";
import FreeVotesIconA from "../../assets/images2/freeVotesSelec.svg";
import LeaderboardIconA from "../../assets/images2/leaderboardSelec.svg";
import analyticIcon from "../../assets/images2/analytic.svg";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import LogoutModal from "../../component/Modals/LogoutModal";
import YouTubeIcon from "@mui/icons-material/YouTube";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import CheckroomOutlinedIcon from "@mui/icons-material/CheckroomOutlined";

export default function NestedList() {
  const navigate = useNavigate();
  const [openLogout, setOpenLogout] = useState(false);
  const { pathname } = useLocation();

  const footballPaths = [
    "goals",
    "tournaments",
    "free-votes",
    "leaderboards",
    "fanzone",
    "international-tournament",
    "clubs",
    "banners",
    "youtube-links",
    "goal-categories",
    "featured-link",
  ];

  const competitionPaths = [
    "advertisements",
    "competitions",
    "competition-videos",
    "vote-payments",
  ];

  const [openFootball, setOpenFootball] = useState(
    footballPaths.some((p) => pathname.includes(p))
  );
  const [openCompetition, setOpenCompetition] = useState(
    competitionPaths.some((p) => pathname.includes(p))
  );
  const fashionPaths = ["fashion-designers"];
  const [openFashion, setOpenFashion] = useState(
    fashionPaths.some((p) => pathname.includes(p))
  );

  useEffect(() => {
    if (footballPaths.some((p) => pathname.includes(p))) {
      setOpenFootball(true);
    }
    if (competitionPaths.some((p) => pathname.includes(p))) {
      setOpenCompetition(true);
    }
    if (pathname.includes("fashion-designers") || pathname.includes("fashion-banner")) {
      setOpenFashion(true);
    }
  }, [pathname]);

  const getPage = (page) => {
    const path = window.location.pathname || "";
    if (page === "fashion-designers" && path.includes("/fashion-designers")) return true;
    const currentPath = path.split("/");
    const pageOpen = currentPath[currentPath.length - 1];
    return pageOpen === page;
  };

  const isGroupActive = (paths) =>
    paths.some((p) => pathname.includes(`/admin/dashboard/${p}`));

  const renderNavItem = (item, nested = false) => (
    <ListItemButton
      key={item.path}
      onClick={item.onClick}
      sx={{
        mb: nested ? 0.6 : 1.2,
        mt: nested ? 0.6 : 0,
        pl: nested ? 4 : 2,
        borderRadius: 1,
      }}
      className={getPage(item.path) ? "active" : ""}
    >
      <ListItemIcon sx={{ minWidth: 40 }}>
        {getPage(item.path) ? (
          item.type === "MuiIcon" ? (
            <item.icon sx={{ color: "#ef364e" }} />
          ) : (
            <img src={item.iconA} alt="" />
          )
        ) : item.type === "MuiIcon" ? (
          <item.icon sx={{ color: nested ? "#666" : "black" }} />
        ) : (
          <img src={item.icon} alt="" />
        )}
      </ListItemIcon>
      <ListItemText
        primary={item.label}
        className={getPage(item.path) ? "active" : ""}
      />
    </ListItemButton>
  );

  const topItems = useMemo(
    () => [
      {
        label: "Home Banner",
        path: "home-banners",
        icon: ViewCarouselIcon,
        iconA: ViewCarouselIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/home-banners"),
      },
      {
        label: "Users",
        path: "users",
        icon: UserIcon,
        iconA: UserIconA,
        onClick: () => navigate("/admin/dashboard/users"),
      },
      {
        label: "Analytics",
        path: "analytics",
        icon: analyticIcon,
        iconA: analyticIcon,
        onClick: () => navigate("/admin/dashboard/analytics"),
      },
    ],
    [navigate]
  );

  const footballItems = useMemo(
    () => [
      {
        label: "Goals",
        path: "goals",
        icon: GoalIcon,
        iconA: GoalIconA,
        onClick: () => navigate("/admin/dashboard/goals"),
      },
      {
        label: "Tournaments",
        path: "tournaments",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/tournaments"),
      },
      {
        label: "Free Votes",
        path: "free-votes",
        icon: FreeVotesIcon,
        iconA: FreeVotesIconA,
        onClick: () => navigate("/admin/dashboard/free-votes"),
      },
      {
        label: "Leaderboards",
        path: "leaderboards",
        icon: LeaderboardIcon,
        iconA: LeaderboardIconA,
        onClick: () => navigate("/admin/dashboard/leaderboards"),
      },
      {
        label: "Fanzone Leaderboard",
        path: "fanzone",
        icon: LeaderboardIcon,
        iconA: LeaderboardIconA,
        onClick: () => navigate("/admin/dashboard/fanzone"),
      },
      {
        label: "International Tournament",
        path: "international-tournament",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/international-tournament"),
      },
      {
        label: "Clubs",
        path: "clubs",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/clubs"),
      },
      {
        label: "Banners",
        path: "banners",
        icon: ViewCarouselIcon,
        iconA: ViewCarouselIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/banners"),
      },
      {
        label: "Youtube Links",
        path: "youtube-links",
        icon: YouTubeIcon,
        iconA: YouTubeIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/youtube-links"),
      },
      {
        label: "Goal Categories",
        path: "goal-categories",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/goal-categories"),
      },
      {
        label: "Featured",
        path: "featured-link",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/featured-link"),
      },
    ],
    [navigate]
  );

  const competitionItems = useMemo(
    () => [
      {
        label: "Advertisement Banner",
        path: "advertisements",
        icon: ViewCarouselIcon,
        iconA: ViewCarouselIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/advertisements"),
      },
      {
        label: "Competitions",
        path: "competitions",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/competitions"),
      },
      {
        label: "Competition Media",
        path: "competition-videos",
        icon: TournamentIcon,
        iconA: TournamentIconA,
        onClick: () => navigate("/admin/dashboard/competition-videos"),
      },
      {
        label: "Vote Payments",
        path: "vote-payments",
        icon: PaymentsOutlinedIcon,
        iconA: PaymentsOutlinedIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/vote-payments"),
      },
    ],
    [navigate]
  );

  const fashionItems = useMemo(
    () => [
      {
        label: "Designers",
        path: "fashion-designers",
        icon: CheckroomOutlinedIcon,
        iconA: CheckroomOutlinedIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/fashion-designers"),
      },
    ],
    [navigate]
  );

  const bottomItems = useMemo(
    () => [
      {
        label: "App Configuration",
        path: "app-configuration",
        icon: AppSettingsAltIcon,
        iconA: AppSettingsAltIcon,
        type: "MuiIcon",
        onClick: () => navigate("/admin/dashboard/app-configuration"),
      },
      {
        label: "Logout",
        path: "logout",
        icon: LogoutIcon,
        iconA: LogoutIcon,
        onClick: () => setOpenLogout(true),
      },
    ],
    [navigate]
  );

  const renderGroup = (key, title, icon, open, setOpen, items, paths, accent) => (
    <Box key={key} component="section" sx={{ mb: 0.5 }}>
      <ListItemButton
        onClick={() => setOpen((v) => !v)}
        sx={{
          mb: 0.25,
          mt: 0.5,
          borderRadius: 1,
          bgcolor: isGroupActive(paths) ? "rgba(239,54,78,0.08)" : "transparent",
        }}
      >
        <ListItemIcon sx={{ minWidth: 40 }}>
          {React.createElement(icon, {
            sx: { color: isGroupActive(paths) ? "#ef364e" : "#333" },
          })}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 13,
                letterSpacing: "0.04em",
                textTransform: "uppercase",
                color: isGroupActive(paths) ? "#ef364e" : "#333",
              }}
            >
              {title}
            </Typography>
          }
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box sx={{ borderLeft: `2px solid ${accent}`, ml: 1.5, pl: 0.5, pb: 0.5 }}>
          {items.map((item) => renderNavItem(item, true))}
        </Box>
      </Collapse>
    </Box>
  );

  return (
    <>
      <List component="nav" aria-labelledby="nested-list-subheader">
        {topItems.map((item) => renderNavItem(item))}

        <Divider sx={{ my: 1.5 }} />

        {renderGroup(
          "football",
          "Football",
          SportsSoccerIcon,
          openFootball,
          setOpenFootball,
          footballItems,
          footballPaths,
          "#2e7d32"
        )}

        {renderGroup(
          "competition",
          "Competition",
          EmojiEventsIcon,
          openCompetition,
          setOpenCompetition,
          competitionItems,
          competitionPaths,
          "#C9A66B"
        )}

        {renderGroup(
          "fashion",
          "Fashion Designer",
          CheckroomOutlinedIcon,
          openFashion,
          setOpenFashion,
          fashionItems,
          fashionPaths,
          "#111827"
        )}

        <Divider sx={{ my: 1.5 }} />

        {bottomItems.map((item) => renderNavItem(item))}
      </List>
      <LogoutModal open={openLogout} setOpen={setOpenLogout} />
    </>
  );
}
